module.exports = __webpack_public_path__ + "static/media/item_46_1.6255fb94.jpg";